export default __webpack_public_path__ + "static/bottomSplash-b6f1d247d7b8ef3daad6be174b745cf6.svg";